export enum SettingsTabType {
  MENU,
  WORKSPACE_SETTINGS,
  PERSONAL_INFO,
  CHANNELS,
  WORKSPACE_MEMBERS,
  SNIPPETS,
  MESSAGE_TAGS,
  BILLING,
}

export default SettingsTabType;